import config from '@config/config';
import FormatDate from './dateFormat';
import { store } from '@store/index';

const getServiceRulesFromRedux = (): any => {
  try {
    const state = store.getState() as any;
    const hrpConfig = state?.serviceRuleMaster?.configs?.['hrp-rules'];
    
    if (hrpConfig?.data) {
      return hrpConfig?.data;
    }

    return null;
  } catch (error) {
    return null;
  }
};

export function ObstetricHistoryCheck(name: string, value: any): boolean {
  let isValid = true;
  
  const serviceRules = getServiceRulesFromRedux();
  const rules = serviceRules || config;
  
  switch (name) {
    case 'shortStature': {
      const minimumHeight = rules?.['height_in_cm_short_stature']?.value || config?.minimumHeight;
      if (config?.shortStatureMin > parseInt(value) || parseInt(value) >= minimumHeight) {
        isValid = false;
      }
      break;
    }
    case 'height': {
      const minimumHeight = rules?.['height_in_cm_short_stature']?.value || config?.minimumHeight;
      if (Number(value) < minimumHeight) {
        isValid = false;
      }
      break;
    }
    case 'weight': {
      const minimumWeight = rules?.['weight_in_kg_underweight']?.value || config?.minimumWeight;
      if (value <= minimumWeight) {
        isValid = false;
      }
      break;
    }
    case 'history': {
      const obstetricHistorySource = rules?.obstetricHistory || config?.obstetricHistory;
      if (
        JSON.parse(obstetricHistorySource.replace(/'/g, '"')).some(
          (element: any) => value.includes(element),
        )
      ) {
        isValid = false;
      }
      break;
    }
  }
  return isValid;
}

export function RoutineANCCondition(name: string, value: any): boolean {
  let isValid = true;
  
  const serviceRules = getServiceRulesFromRedux();
  const rules = serviceRules || config;
  
  switch (name) {
    case 'hb': {
      const severAnaemiaLevel = rules?.['hb_gm_hb_severe_anaemia']?.value || config?.hb;
      if (value >= severAnaemiaLevel) {
        isValid = false;
      }
      break;
    }
    case 'gestationalWeight':
      if (value !== null && value !== undefined && value !== 0 && (value < 2 || value > 3)) {
        isValid = false;
      }
      break;   
    case 'ppTest': {
      const ppTestLevel = rules.gestational_diabetes_mellitus?.pp?.max || config?.ppTest;
      if (value > ppTestLevel || value === ppTestLevel) {
        isValid = false;
      }
      break;
    }
    case 'ogttTest': {
      const ogttTestLevel = rules.gestational_diabetes_mellitus?.ogtt?.max || config?.ogttTest;
      if (value > ogttTestLevel || value === ogttTestLevel) {
        isValid = false;
      }
      break;
    }
    case 'foetalPresentation': {
      if (
        JSON.parse(config?.foetalPresentation.replace(/'/g, '"')).some(
          (element: any) => value === element,
        )
      ) {
        isValid = false;
      }
      break;
    }
    case 'isBpSystolicHRP': {
      const systolicLevel = rules?.['bp_systolic_mm_hg_bp_systolic_mm_hg__hypertension_systolic_gteq_140_mm_hg']?.value || config?.bpSystolic;
      if (value < Number(systolicLevel)) {
        isValid = false;
      }
      break;
    }
    case 'isBpDiastolicHRP': {
      const diastolicLevel = rules?.['bp_diastolic_mm_hg_bp_diastolic_mm_hg__hypertension_systolic_gteq_140_mm_hg']?.value || config?.bpDiastolic;
      if (value < Number(diastolicLevel)) {
        isValid = false;
      }
      break;
    }
    case 'isSymptomsHRP': {
      if (
        JSON.parse(config?.otherSymptoms.replace(/'/g, '"')).some(
          (element: any) => value.includes(element),
        )
      ) {
        isValid = false;
      }
      break;
    }
  }
  return isValid;
}

export function SpecialTestCheck(name: string, value: any): boolean {
  let isValid = true;
  
  const serviceRules = getServiceRulesFromRedux();
  const rules = serviceRules || config;
  
  switch (name) {
    case 'bGroupAndRhFactor': {
      if (JSON.parse(config?.bloodGroup.replace(/'/g, '"')).includes(value)) {
        isValid = false;
      }
      break;
    }
    case 'vdrlTest': {
      if (value === config?.vdrlTest) {
        isValid = false;
      }
      break;
    }
    case 'hivScreening': {
      if (value === config?.hivTest) {
        isValid = false;
      }
      break;
    }
    case 'hbsagTest': {
      if (value === config?.hbsagTest) {
        isValid = false;
      }
      break;
    }
    case 'thyroidTest': {
      if (value === config?.thyroidTest) {
        isValid = false;
      }
      break;
    }
    case 'tbTest': {
      if (value === config?.tbTest) {
        isValid = false;
      }
      break;
    }
    case 'malariaTest': {
      if (value === config?.malariaTest) {
        isValid = false;
      }
      break;
    }
  }
  return isValid;
}

export const isValueContainsOnlyDigits = (value: any) => {
  return /^\d+$/.test(value);
};

export const calculateCompletedWeeksPregnancy = (lmp: any) => {
    const msInWeek = 7 * 24 * 60 * 60 * 1000;
    const currentDate = new Date();
    const date2 = new Date(FormatDate(lmp));
    const diffInMs = Math.abs(currentDate.getTime() - date2.getTime());
    const diffInWeeks = Math.floor(diffInMs / msInWeek);
    return diffInWeeks || 0;
};
